import { ReactComponent as Icon } from '../../assets/icons/car.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" />;
}
